import React, { useMemo } from 'react';

import EntityLink from '../V5Gadget/Matrix/GroupingCellRenderer/EntityLink';
import { FleetopsGridCellRendererParams } from '../../types/agGrid';
import GridCellErrorBoundary from '../GridCellErrorBoundary';
import Cell from '../V5Gadget/Matrix/Cell';
import Row from '../Common/Row';
import Tooltip from '../Tooltip';

const EntityCell = (props: FleetopsGridCellRendererParams) => {
  const { value, colDef, node } = props;
  const displayValue = useMemo(() => {
    if (Array.isArray(value)) {
      return value.join(', ');
    }
    return value;
  }, [value]);

  return (
    <Cell>
      <Row centerAlign>
        <Tooltip content={displayValue}>
          <span>{displayValue}</span>
        </Tooltip>
        <EntityLink colDef={colDef} value={value} node={node} />
      </Row>
    </Cell>
  );
};

const Gate = (params: FleetopsGridCellRendererParams) => (
  <GridCellErrorBoundary
    params={params}
    childComponent={<EntityCell {...params} />}
  />
);

export default Gate;
